import { render, staticRenderFns } from "./sidebar-terminplanung-header.vue?vue&type=template&id=5847e5c4&scoped=true"
import script from "./sidebar-terminplanung-header.vue?vue&type=script&lang=js"
export * from "./sidebar-terminplanung-header.vue?vue&type=script&lang=js"
import style0 from "./sidebar-terminplanung-header.vue?vue&type=style&index=0&id=5847e5c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5847e5c4",
  null
  
)

export default component.exports